import { Enums } from './../common/enums';
import { MessageService } from '../services/message.service';
import { Message } from '../common/message';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material';
import { ConfirmDeleteDialogComponent } from '../dialog/confirm-delete-dialog/confirm-delete-dialog.component';
import { UserService } from '../services/user.service';
import { User } from '../models/user';

let ELEMENT_DATA = [];

@Component({
  selector: 'app-user',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = ['SN','name', 'email', 'role', 'active', 'actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  resource: User = new User();

  constructor(private enums: Enums, private dialog: MatDialog, private service: UserService, private formBuilder: FormBuilder, private msg: MessageService) { }

  ngOnInit() {
    this.setMessageForm();
    this.getResources();
  }


  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      role: ['', Validators.required],
      active: ['', Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll()
      .subscribe(result => {
        ELEMENT_DATA = ELEMENT_DATA.concat(result);
        this.updateDataSource();
      })
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave() {

    this.submitted = true;

    if (!this.resource || !this.resource.name || this.resource.name.trim() == '') {
      return;
    }

    if (!this.resource || !this.resource.email || this.resource.email.trim() == '') {
      return;
    }

    if (!this.resource || !this.resource.role || this.resource.role.trim() == '') {
      return;
    }

    if (this.form.controls.email.errors) {
      return;
    }

    if (this.form.controls.name.errors) {
      return;
    }

    if (this.form.controls.role.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement();
    } else {
      this.addElement();
    }

  }

  resetForm(ret?: boolean) {
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement() {
    this.service.create(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.SAVE);
        ELEMENT_DATA.push(result);
        this.updateDataSource();
        this.resetForm();
      }, (err : any) => {
        if(err.status == 422){
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      })

  }

  updateElement() {
    this.service.update(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.UPDATE);
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id) {
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        })

        this.updateDataSource();
        this.resetForm(true);
      }, (err : any) => {
        if(err.status == 422){
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      })
  }

  editElement(ele: User) {

    this.isFormDisplay = true;
    this.isAddNew = false;

    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setEmail(ele.email);
    this.resource.setRole(ele.role);
    this.resource.setActive(ele.active);
    this.resource.setVisits(ele.visits);

  }

  deleteElement(ele) {
    this.dialog.open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe(result => {
        if (result === "true") {
          this.service.delete(ele.id)
            .subscribe(result => {
              this.msg.alert(Message.DELETE);
              let index = ELEMENT_DATA.indexOf(ele);
              ELEMENT_DATA.splice(index, 1);
              this.updateDataSource();
            })
        } else {
          return;
        }
      });

  }

}

